const _CHAVE = 'empregare-auth-event';

export function broadcastAuth(evento) {
    try {
        const t = Date.now();
        // Marca como já processado nesta aba antes de disparar o evento,
        // para que visibilitychange não o reprocesse na aba que originou o evento.
        sessionStorage.setItem(`${_CHAVE}-${t}`, '1');
        localStorage.setItem(_CHAVE, JSON.stringify({ evento, t }));
    } catch (e) { }
}

export function onAuthBroadcast(callback) {
    const _carregadoEm = Date.now();

    const _processarEvento = () => {
        try {
            const stored = localStorage.getItem(_CHAVE);
            if (!stored) return;
            const { evento, t } = JSON.parse(stored);
            if (t < _carregadoEm) return; // evento anterior à abertura desta aba — ignorar
            const processadoKey = `${_CHAVE}-${t}`;
            if (sessionStorage.getItem(processadoKey)) return; // já processado nesta aba
            sessionStorage.setItem(processadoKey, '1');
            callback(evento);
        } catch (e) { }
    };

    // Abas ativas: recebem o storage event em tempo real
    window.addEventListener('storage', (e) => {
        if (e.key === _CHAVE && e.newValue) _processarEvento();
    });

    // Abas congeladas pelo Chrome: processam ao ficarem visíveis novamente
    document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') _processarEvento();
    });
}
